export default "__VITE_ASSET__ad7ca44a__"